import { useContext } from 'react';
import { LangContext } from '@/context/LangProvider';

interface CharacterCountProps {
  maxCharacters: number;
  currentCharacters: number;
  errorMessage?: string;
  className?: string;
}

function CharacterCount({
  maxCharacters,
  currentCharacters,
  errorMessage,
  className = 'flex justify-between items-center',
}: CharacterCountProps) {
  const { lang } = useContext(LangContext);

  const remainingCharacters = maxCharacters - currentCharacters;

  return (
    <div className={className}>
      <p className="text-xs text-light-dark">
        {remainingCharacters} {lang.get('msg.charactersLeft')}
      </p>
      {errorMessage && <p className="text-xs text-red-600 font-medium">{lang.get(errorMessage)}</p>}
    </div>
  );
}

export default CharacterCount;
